import script from "./OttawoodInvoiceSystem.vue?vue&type=script&setup=true&lang=js"
export * from "./OttawoodInvoiceSystem.vue?vue&type=script&setup=true&lang=js"

import "./OttawoodInvoiceSystem.vue?vue&type=style&index=0&id=c704afc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c704afc0"]])

export default __exports__